import React, { Component } from 'react';
import documentSrc from 'images/document_el.svg';
import { Spinner } from 'ui';
import ElementBase from '../base.jsx';

class DocumentElement extends Component {
  constructor(props) {
    super(props);
    this.uploadDocument = this.uploadDocument.bind(this);
  }

  uploadDocument() {
    const { document_id: documentId } = this.props.content;
    this.props.uploadDocument(documentId);
  }

  renderUploader() {
    const { status, errorMessage } = this.props.content;
    return (
      <div className="EditorElement-fileHandler">
        <div className="EditorElement-uploadArea">
          <img
            src={documentSrc}
            className="EditorElement-icon"
            alt={t('lessons.editor.elements.document')}
          />
          {!status && (
            <button
              type="button"
              onClick={this.uploadDocument}
              className="NewButton NewButton--white"
              children="Choose a Document, Presentation, or PDF to Upload"
            />
          )}
          {status === 'error' && (
            <div className="CommentForm-errorMessage">{errorMessage}</div>
          )}
          {status === 'converting' && (
            <div className="c-brand-gray">
              <Spinner className="mr-16" />
              Preparing Document - This may take a few seconds...
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDocument() {
    return (
      <div className="EditorElement-fileHandler">
        <iframe
          title={t('lessons.editor.elements.document')}
          src={this.props.content.url}
          className="EditorElement-DocumentViewer"
          scrolling="false"
          frameBorder="0"
        />
      </div>
    );
  }

  renderProcessing() {
    return (
      <div className="EditorElement-fileHandler">
        <Spinner className="mr-16" />
        {t('drafts.documents_processing')}
      </div>
    );
  }

  renderBody() {
    const { url, processing } = this.props.content;
    if (url) return this.renderDocument(url);
    if (processing) return this.renderProcessing();
    return this.renderUploader();
  }

  render() {
    return <div className="EditorElement-content">{this.renderBody()}</div>;
  }
}

export default ElementBase(DocumentElement);
